import React from 'react';

import Questions from 'features/bot-builder/components/Common/Questions';
import { Apps } from 'constants/global';
import WelcomeHero from '../components/GetStartedPage/WelcomeHero';
import SelectFilePanel from '../components/GetStartedPage/SelectFilePanel';

const GetStartedPage: React.FC = () => {
  return (
    <main className="min-h-screen justify-center items-center bg-background-main">
      <div className="w-full h-full flex flex-col lg:flex-row justify-center feature-gradient-bg">
        <div className="w-full lg:w-[500px] lg:max-w-[500px] p-4 lg:p-[60px]">
          <WelcomeHero />
        </div>

        <div className="w-full lg:w-3/5 lg:max-w-[800px] px-4 lg:px-[60px] pt-4 lg:pt-[60px] pb-6 lg:pb-[72px]">
          <div className="flex text-text-secondary mb-8">
            <div className="font-bold">
              <p className="text-xs lg:text-sm font-medium text-text-primary">
                START
              </p>
              <h3 className="text-xl lg:text-[28px] text-text-primary">
                Upload Image
              </h3>
            </div>
          </div>

          <div className="bg-background rounded-lg p-4 lg:p-10">
            <SelectFilePanel />
          </div>
        </div>
      </div>
      <Questions appType={Apps.IMAGE_TO_IMAGE} />
    </main>
  );
};

export default GetStartedPage;
